import type { HttpBackendOptions } from 'i18next-http-backend';
import type { Language } from '@/types/locales';
import dayjs from 'dayjs';
import i18n from 'i18next';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import fallbackTranslation from './locales/en.json';

const loadBundle = async (loadPath: string): Promise<object> => {
    const result = (await import((`./locales/${loadPath}.json`))) as { default: object };
    return result.default;
};

const initLocale = async (locale: Language) => {
    dayjs.locale(locale);

    return i18n
        .use(initReactI18next)
        .use(HttpBackend)
        .init<HttpBackendOptions>({
            fallbackLng: 'en',
            debug: false,
            lng: locale,
            load: 'languageOnly',
            interpolation: {
                escapeValue: false
            },
            backend: {
                loadPath: '{{lng}}',
                request: (_options, url, _payload, callback) => {
                    loadBundle(url)
                        .then((data) => {
                            callback(null, {
                                status: 200,
                                data: JSON.stringify(data)
                            });
                        })
                        .catch((e) => {
                            console.error(e);

                            callback(null, {
                                status: 200,
                                data: JSON.stringify(fallbackTranslation)
                            });
                        });
                }
            }
        });
};

export { i18n, initLocale };
